<template>
  <el-card>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      @checkboxChange="checkboxChange"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openCopyDialog="copyFormDialogVisible = true"
        @openEditFormDialog="openEditFormDialog"
        :orgRow="orgRow"
        :checked-count="checkedCount"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="800px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :sampleTemplateCode="editFormDialogOptions.code"
        :orgRow="orgRow"
        :isadd="editFormDialogOptions.isadd"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">
          {{ this.$l('INDEX.btn_cancel') || 取消 }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || 保存 }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      v-if="copyFormDialogVisible"
      show-close
      :visible.sync="copyFormDialogVisible"
      width="500px"
      :title="$l('dialog_title_copy') || '复制到的产品分类'"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :before-close="cancelCopy"
    >
      <el-form ref="copyForm" :model="formCopyData" :rules="rules" size="small">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="sampleCategoryCode" :label="$l('form_label_Product_classification') || '产品分类'">
              <el-cascader
                :options="copySelectList"
                v-model="selector"
                :props="cascaderProps"
                @change="changeSampleCategory"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="cancelCopy()">
          {{ this.$l('INDEX.btn_cancel') || 取消 }}
        </el-button>
        <el-button type="primary" size="small" @click="copy()">{{
          this.$l('INDEX.btn_save') || 保存
        }}</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
      copyFormDialogVisible: false,
      orgRow: {},
      formCopyData: {
        productLine: '',
        sampleCategoryCode: '',
      },
      rules: {
        sampleCategoryCode: [
          { required: true, message: '请选择产品分类', trigger: 'change' },
        ],
      },
      cascaderProps: {
        value: 'categoryCode',
        label: 'categoryName',
        children: 'childs',
      },
      copySelectList: [],
      selector: [],
      checkList: [],
    }
  },
  computed: {
    checkedCount() {
      return !this.checkList ? 0 : this.checkList.length
    },
  },
  mounted() {
    this.$eventBus.$on('sampleTemplatList', (row) => {
      this.orgRow = row
      this.$refs.main.removeCheckboxRow()
      this.$refs.header.orgChange(row)
    })
    this.getCopySelect()
  },
  methods: {
    cancelCopy() {
      this.formCopyData = {
        productLine: '',
        sampleCategoryCode: '',
      }
      this.selector = []
      this.copyFormDialogVisible = false
    },
    getCopySelect() {
      this.$api.masSampleInputTemplateCopySelectTreeApi().then((res) => {
        this.copySelectList = res.body.data || []
        console.log(res.body)
      })
    },
    getData(form) {
      this.parentDep = {}
      this.loading = true
      this.$api
        .masSampleInputTemplateRightListeApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit:
          this.$l('form_label_Edit_sample_template_information') ||
          '编辑样品模板信息',
        add:
          this.$l('form_label_Add_sample_template_information') ||
          '添加样品模板信息',
        detail:
          this.$l('form_label_Sample_template_information_details') ||
          '样品模板信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        isadd: type === 'add',
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    checkboxChange(data) {
      this.checkList = data
    },
    changeSampleCategory(data) {
      if (data && data.length > 1) {
        this.formCopyData.productLine = data[0]
        this.formCopyData.sampleCategoryCode = data[1]
      }
    },
    async copy() {
      const result = await validate.formValidate([this.$refs.copyForm])
      if (!result) {
        return
      }
      const tmpForm = { ...this.formCopyData, checkList: this.checkList }
      this.loadingOpen()
      this.$api
        .masSampleInputTemplateCopyApi(tmpForm)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_copy_ok') || '复制成功！',
            type: 'success',
          })
          this.cancelCopy()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
